import clsx from "clsx";
import merge from "lodash/merge";
import { FunctionComponent, JSX } from "react";

import { type ContentCardArticle } from "@ui/components/content-cards/content-cards.types";
import SplitContentCard from "@ui/components/content-cards/SplitContentCard";
import { type Pattern } from "@ui/components/patterns/patterns.types";
import * as standardStyles from "@ui/components/patterns/ThreeGridPattern/ThreeGridPattern.css";
import { useComponentConfig } from "@ui/context/component-config-context";
import { sharedStyles } from "@ui/shared-styles";
import { getContexts } from "@ui/utils/patterns";

import * as styles from "./ThreeGridOverflowPattern.css";

export interface Props extends Pattern {
  componentContext?: string;
}

const ThreeGridOverflowPattern: FunctionComponent<Props> = (props) => {
  const threeGridOverflowPatternConfig = useComponentConfig(
    "threeGridOverflowPattern",
    props.componentContext || "",
  );

  const {
    cardsData,
    gaComponentName = "three_grid_overflow_pattern",
    mobileCardContext = "threeGridPattern",
    desktopCardContext,
    showGridBorders = false,
    mobileCardClassName,
    desktopCardClassName,
    desktopContainerClassName,
  } = merge({}, threeGridOverflowPatternConfig, props);

  const { mobileContext, desktopContext } = getContexts(
    cardsData.length,
    mobileCardContext,
    desktopCardContext,
  );

  const getDesktopCard = (entry: ContentCardArticle, idx: number) => {
    return (
      <div
        className={clsx(showGridBorders && standardStyles.gridBorders)}
        key={entry.id}
      >
        <SplitContentCard
          {...entry}
          componentContext={desktopContext[idx]}
          gaComponentName={gaComponentName}
          className={desktopCardClassName}
        />
      </div>
    );
  };

  const getMobileCard = (entry: ContentCardArticle, idx: number) => {
    return (
      <div
        className={clsx(sharedStyles.contentCard.fixedWidthCard)}
        key={entry.id}
      >
        <SplitContentCard
          {...entry}
          componentContext={mobileContext[idx]}
          gaComponentName={gaComponentName}
          className={mobileCardClassName}
        />
      </div>
    );
  };

  const desktopCards: Array<JSX.Element> = [];
  const mobileCards: Array<JSX.Element> = [];

  cardsData.forEach((entry, idx) => {
    desktopCards.push(getDesktopCard(entry, idx));
    mobileCards.push(getMobileCard(entry, idx));
  });

  return (
    <div>
      <div className={clsx(styles.desktopContainer, desktopContainerClassName)}>
        {desktopCards}
      </div>
      <div className={styles.mobileContainer}>
        <div
          className={clsx(
            styles.overflowInnerContainer,
            sharedStyles.layout.hideScrollbar,
          )}
        >
          {mobileCards}
        </div>
      </div>
    </div>
  );
};

export default ThreeGridOverflowPattern;
